import { ToolType } from "./types";

import { serverGetProgressOverviewData } from "api/api-server-data";
import { t } from "i18n/i18n";

/**
 * Fetches the same progress overview as the Progress tab (GET progress_overview).
 * Aggregated across the student's work; not scoped to the current course or section.
 */
export const fetchProgressOverviewForTool = async () => {
  const data = await serverGetProgressOverviewData();
  return {
    note: t("ai.progress_overview_tool_note"),
    averageOutcomeScore: data.averageOutcomeScore,
    totalOutcomesAssessed: data.totalOutcomesAssessed,
    outcomeGroups: data.outcomeGroups,
  };
};

export const getProgressOverviewTool: ToolType<Record<string, never>> = {
  name: "get_progress_overview",
  description:
    "Load the student's progress overview: learning-outcome scores aggregated across their work " +
    "(organization-wide, not limited to the current course or section). Same data as the Progress view. " +
    "Use when they ask how they are doing, about outcomes, rubric levels, or grades.",
  progressMessage: () => t("ai.progress_overview_tool_progress"),
  parameters: {
    type: "object",
    properties: {},
    additionalProperties: false,
  },
  callback: fetchProgressOverviewForTool,
};
